import { PaymentResponse } from "../api/PaymentResponse";

export class PayResult {
	paReq: string;
	url: string;
  cReq : string;
  threeDSSessionData: string;
  successUrl: string;
  
	constructor(res: PaymentResponse) {
		this.paReq = res.paReq;
		this.cReq = res.cReq;
		this.url = res.url;
		this.threeDSSessionData = res.threeDSSessionData;
		this.successUrl = res.successUrl;
	}
}